export default __webpack_public_path__ + "static/media/logo_100.8334c0a5.png";